import * as React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-responsive-modal/styles.css";

import { useCreationDispatch, useCreationState } from "../creationFlowHooks";

import Layout from "../shared/Layout";
import Hero from "../shared/Hero";
import CustomerDetailsForm from "./CustomerDetailsForm";
import Button from "../shared/Button";
import { useSubmitUser } from "../poster/posterHooks";
import { setUser } from "../creationFlowActions";

const CustomerDetails: React.FC = () => {
  const { error } = useCreationState();
  const history = useHistory();
  const dispatch = useCreationDispatch();
  const { loading, submitted, submitUser } = useSubmitUser();


  const onOpenTermsModal = () => {};
  const userDetailsFormRef = React.useRef<HTMLFormElement>();
  React.useEffect(() => {
    if (error) {
      history.replace("/");
      toast.error(error);
    }
  }, [error, history]);

  React.useEffect(() => {
    if (submitted) {
      history.replace("/your-time");
    }
  }, [submitted]);

  const onNext = () => {
    if (userDetailsFormRef && userDetailsFormRef.current) {
      userDetailsFormRef.current.requestSubmit();
    }    
  }
  const onUserDetails = (user) => {
    dispatch(setUser({
      firstName: user.firstName,
      lastName: user.lastName,
      emailAddress: "na@smiledealers.com",
      marketingOptIn: false
    }));
    submitUser({
      firstName: user.firstName,
      lastName: user.lastName,
      emailAddress: "na@smiledealers.com",
      marketingOptIn: false
    });
  }
  return (
    <Layout>
      <Hero role="DETAILS" />
      <div className="flex flex-col flex-1 items-center mx-5 overflow-hidden h-full">
        <div className="mt-7">
          <h1 className="font-text text-2xl text-center">
            About you
          </h1>
          <p className="font-text text-smallLabel text-center">
            Tell us about yourself
          </p>
        </div>
        <div className="flex flex-col flex-grow overflow-y-auto mt-4 mb-4 w-full rounded-lg">
          <div>
            <CustomerDetailsForm
              onSubmit={onUserDetails}
              openTermsModal={onOpenTermsModal}
              formRef={userDetailsFormRef}
            />
          </div>
          <div className="flex items-end justify-center py-2">
            <div className="flex ">
            <Button
              theme="primary"
              className="self-end"
              onClick={onNext}
              isLoading={loading}          
            >
              Next
            </Button>
            </div>
          </div>
        </div>        
      </div>
    </Layout>
  );
};

export default CustomerDetails;
